import { store } from '@reduxLocal/persistState';
import { DataObjectType, OptionTypes } from '../types/validatorTypes';
import {
	APPLY_VALIDATION,
	MODIFY_VALIDATION,
} from '@reduxLocal/actions/types';
import { isEqual } from 'lodash';

export default async function updateStoreHandler({
	index,
	option,
}: {
	index: number;
	option: OptionTypes[];
}) {
	// Use store.getState() to get the current state from the Redux store
	const dataCreator = store.getState().uploadPreview.present.dataHeld;
	const data: DataObjectType = dataCreator[index];

	// Check if validation property exists on the data object
	if (data.validation) {
		const { validation } = data;
		const validationKeys = Object.keys(validation);
		// Check if the validation property exists
		if (validationKeys.includes(option.type)) {
			store.dispatch({
				type: MODIFY_VALIDATION,
				payload: { key: option.type, value: option.value },
				index: index,
			});
			return;
		} else {
			// Create a new validation object
			const newValidation = {
				...data.validation,
				[option.type]: option.value,
			};

			// Push the new validation into the array
			store.dispatch({
				type: APPLY_VALIDATION,
				payload: newValidation,
				index: index,
			});
		}
	} else {
		const newValidation = {
			...data.validation,
			[option.type]: option.value,
		};
		// Create a new array with the new validation and add it to the validation property
		store.dispatch({
			type: APPLY_VALIDATION,
			payload: newValidation,
			index: index,
		});
	}

	// Update the data object in the store
}
